import {
  Sparkles,
  Image,
  Smartphone,
  LayoutDashboard,
  Calendar,
  MessageSquare,
  Bell,
  Camera,
  ShieldCheck,
  Zap,
  type LucideIcon,
} from "lucide-react";

/** Curated lucide set referenced by `icon` strings in lib/changelog.ts. */
export const CHANGELOG_ICONS: Record<string, LucideIcon> = {
  sparkles: Sparkles,
  image: Image,
  smartphone: Smartphone,
  layout: LayoutDashboard,
  calendar: Calendar,
  message: MessageSquare,
  bell: Bell,
  camera: Camera,
  shield: ShieldCheck,
  zap: Zap,
};

export function changelogIcon(name: string): LucideIcon {
  return CHANGELOG_ICONS[name] ?? Sparkles;
}
